import NoFunds from './noFunds'
import { PulseCard, SectionError } from 'components/states'
import AccessPay from './accessPay'
import useGetFunds from './hooks/useGetFunds'
import MoneyPools from './moneyPools'
import CashBoxes from './cashBoxes'

/**
 * The صندوق‌ها tab.
 *
 * One vertical rhythm for the whole screen: a single `flex flex-col gap-3`
 * column whose children are the payables hero, the cashbox cards, the banner
 * and the moneypool cards. That is why `MoneyPools` / `CashBoxes` render
 * fragments rather than wrapper `div`s — a wrapper would collapse each group
 * into one flex child and the gap between cards inside it would come from
 * per-item margins instead, which is exactly how this screen drifted out of
 * step with the home page.
 *
 * Chrome, spacing and type match `pages/dashboard/home`: `bg-canvas` behind
 * white `rounded-card` surfaces with a `divider` hairline, `px-3` gutters, and
 * the shared fa-IR money formatter.
 */
export default function Funds() {
    const { moneyPools, cashBoxes, isLoading, isError, refetch } = useGetFunds()

    if (isLoading) {
        return (
            <div className="bg-canvas min-h-screen px-3 pt-4 flex flex-col gap-3">
                <PulseCard />
                <PulseCard />
            </div>
        )
    }

    // Used to fall through to the spinner and spin forever: the branch tested
    // `!moneyPools`, which stays undefined on error.
    if (isError || !moneyPools) {
        return (
            <div className="bg-canvas min-h-screen px-3 pt-4">
                <SectionError onRetry={() => refetch()} />
            </div>
        )
    }

    if (moneyPools.length === 0 && (cashBoxes?.length ?? 0) === 0) {
        return (
            <div className="bg-canvas min-h-screen">
                <NoFunds />
            </div>
        )
    }

    return (
        <div className="bg-canvas min-h-screen">
            <div className="px-3 pt-4 pb-6 flex flex-col gap-3">
                <AccessPay />
                {cashBoxes && <CashBoxes cashBoxes={cashBoxes} />}
                <MoneyPools moneyPools={moneyPools} />
            </div>
        </div>
    )
}
